//const dates = require( "./dates.js" );
//const i18n = require( "./i18n.js" );
import dates from "./dates.js";
import i18n from "./i18n.js";

const dateType = lang => {
  if ( lang === "eng" || lang === "en" ) return dates.types.ENG;

  return dates.types.RUS4Y;
};

//convert attribute value from backend format to frontend
//type must be in lowercase
const valueBackToFront = ( v, type, refsToo, lang ) => {
  if ( v && typeof( v ) == "object" && type !== "reference" ) v = v.value;
  
	switch ( type ) {
		case "xsd:date":
		case "http://www.w3.org/2001/xmlschema#date":
			v = dates.format( v, dates.types.ISO, dateType( lang ), false, true, false );
		break;
		
		case "xsd:datetime":
		case "http://www.w3.org/2001/xmlschema#datetime":
			v = dates.format( v, dates.types.ISO, dateType( lang ), true, true, false );
		break;

		case "xsd:boolean":
		case "http://www.w3.org/2001/xmlschema#boolean":
			v = ( v === true || v === "true" ? i18n.t( "Yes", lang ) : ( v === false || v === "false" ? i18n.t( "No", lang ) : "" ) )
		break;
			
    case "reference":
      v = refsToo ? ( v.name ? v.name : v.id ) : v;
    break;
	}
	
	return v;
};

//convert attribute value from frontend format to backend
//type must be in lowercase
const valueFrontToBack = ( v, type, lang ) => {
  if ( v && typeof( v ) == "object" && type !== "reference" ) v = v.value;

	switch ( type ) {
		case "xsd:date":
		case "http://www.w3.org/2001/xmlschema#date":
			v = dates.format( v, dateType( lang ), dates.types.ISO, false, true, false );
		break;
		
		case "xsd:datetime":
		case "http://www.w3.org/2001/xmlschema#datetime":
			v = dates.format( v, dateType( lang ), dates.types.ISO, true, true, false );
		break;

		case "xsd:boolean":
		case "http://www.w3.org/2001/xmlschema#boolean":
			v = v === "true" || v == i18n.t( "Yes", lang ) || v == i18n.t( "yes", lang ) ? true : false;
		break;
	}
	
	return v;
};

/*
module.exports = {
  valueBackToFront,
  valueFrontToBack
};
/**/


export default {
  valueBackToFront,
  valueFrontToBack
}
/**/